import { create } from 'zustand';

/** Lets the study view expose the active slide's ICC color toggle in the global
 *  bottom status bar (rendered by AppLayout above all routes). */
interface ColorState {
  available: boolean;
  enabled: boolean;
  name?: string;
  nameLoading: boolean;
  /** The slide has a profile that could not be applied: raw colour, said so. */
  unavailable: boolean;
  toggle?: () => void;
  set: (s: {
    available: boolean;
    enabled: boolean;
    name?: string;
    nameLoading: boolean;
    unavailable: boolean;
    toggle: () => void;
  }) => void;
  clear: () => void;
}

export const useColorStore = create<ColorState>((set) => ({
  available: false,
  enabled: false,
  nameLoading: false,
  unavailable: false,
  set: (s) => set(s),
  clear: () =>
    set({ available: false, enabled: false, name: undefined, nameLoading: false, unavailable: false, toggle: undefined }),
}));
